import React from "react";
import RadioBlocks from "src/components/Input/RadioBlocks/RadioBlocks";
import { Wall } from "src/types/configuration";
import { useConfiguration } from "src/contexts/ConfigurationContext";
// @ts-ignore
import cloneDeep from "lodash/cloneDeep";
import RadioBlocksExtended from "../RadioBlocksExtended/RadioBlocksExtended";
import { getDisabledWindows } from "src/helpers/wallValidation";

export const windows = [
  {
    id: 100,
    name: "Geen raam",
    imageUrl: `${process.env.PUBLIC_URL}/images/empty.svg`,
    color: "",
    value: "empty",
    price: 0,
    description: "",
  },
  {
    id: 1,
    name: "Vast raam",
    imageUrl: `${process.env.PUBLIC_URL}/images/window.png`,
    color: "",
    value: "raam",
    price: 0,
    description: "",
  },
  {
    id: 2,
    name: "Uitzetraam",
    imageUrl: `${process.env.PUBLIC_URL}/images/window-1.png`,
    color: "",
    value: "vleugelraam",
    price: 0,
    description: "",
  },
];

interface WindowSelectProps {
  wall?: Wall;
  value: string;
  disableChoice?: boolean;
  onChange: (value: string) => void;
}

const WindowSelect: React.FC<WindowSelectProps> = ({
  wall,
  value,
  disableChoice,
  onChange,
}) => {
  const { state, configurator } = useConfiguration();

  // Get disabled windows using the helper function
  const availableWindows = ["raam", "vleugelraam"];
  const disableValues = getDisabledWindows(
    wall,
    configurator,
    state.roofType,
    disableChoice,
    availableWindows
  );

  // Reset value if all windows are disabled
  if (disableValues.length === availableWindows.length) {
    value = "empty";
  }

  return (
    <>
      <RadioBlocksExtended
        blocks={windows}
        value={value}
        disableValues={disableValues}
        onChange={onChange}
        className={"window-radio-blocks"}
        stopPropagation={true}
      />
    </>
  );
};

export default WindowSelect;
